exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "option-switch{display:block;margin-bottom:22px;height:37px}option-switch .locked{pointer-events:none}option-switch .request-type-button{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;padding:0;width:50%;height:37px;line-height:37px;background-color:#eaebed;border:.5px solid #0072c9;cursor:pointer;display:inline-block}option-switch .request-type-button p{color:#aeaeae;font-family:Stag Sans!important;font-size:13px;text-align:center;text-transform:uppercase}option-switch .request-type-button:not(.active){box-shadow:inset -2px 0 2px 0 #aeaeae}option-switch .request-type-button:not(.active).shadow-on-left{box-shadow:inset 2px 0 2px 0 #aeaeae}option-switch .request-type-button.active{height:37px;background-color:#0072c9;border:1px solid #0072c9;box-shadow:none}option-switch .request-type-button.active p{color:#fff!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/components/optionSwitch/optionSwitch.scss
// module id = 996
// module chunks = 0